import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function notasFiscaisRecebidas(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@notasFiscaisRecebidas/FIND_DATA':
      case '@notasFiscaisRecebidas/UPDATE_DATA':
      case '@notasFiscaisRecebidas/DELETE_DATA':
      case '@notasFiscaisRecebidas/STORE_DATA':
      case '@notasFiscaisRecebidas/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@notasFiscaisRecebidas/SUCCESS_REMOVE':
      case '@notasFiscaisRecebidas/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@notasFiscaisRecebidas/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@notasFiscaisRecebidas/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@notasFiscaisRecebidas/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
